import { useState, useCallback } from 'react';
import { login as apiLogin } from '../services/api';

const SCHEDULE_AUTH_KEY = 'scheduleAuth';
const ADMIN_AUTH_KEY = 'adminAuth';
const CHOIR_AUTH_KEY = 'choirAuth';
const ADMIN_MODE_KEY = 'adminMode';

export function useAuth() {
  const [isScheduleAuthenticated, setIsScheduleAuthenticated] = useState(() => {
    return sessionStorage.getItem(SCHEDULE_AUTH_KEY) === 'true';
  });

  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(() => {
    return sessionStorage.getItem(ADMIN_AUTH_KEY) === 'true';
  });

  const [isChoirAuthenticated, setIsChoirAuthenticated] = useState(() => {
    return sessionStorage.getItem(CHOIR_AUTH_KEY) === 'true';
  });

  const [isAdminMode, setIsAdminMode] = useState(() => {
    return localStorage.getItem(ADMIN_MODE_KEY) === 'true';
  });

  const loginForSchedule = useCallback(async (password: string): Promise<boolean> => {
    const result = await apiLogin(password);
    if (result.success) {
      sessionStorage.setItem(SCHEDULE_AUTH_KEY, 'true');
      setIsScheduleAuthenticated(true);
      return true;
    }
    return false;
  }, []);

  const loginForAdmin = useCallback(async (password: string): Promise<boolean> => {
    const result = await apiLogin(password);
    if (result.success) {
      sessionStorage.setItem(ADMIN_AUTH_KEY, 'true');
      setIsAdminAuthenticated(true);
      return true;
    }
    return false;
  }, []);

  const loginForChoir = useCallback(async (password: string): Promise<boolean> => {
    const result = await apiLogin(password);
    if (result.success) {
      sessionStorage.setItem(CHOIR_AUTH_KEY, 'true');
      setIsChoirAuthenticated(true);
      return true;
    }
    return false;
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem(SCHEDULE_AUTH_KEY);
    sessionStorage.removeItem(ADMIN_AUTH_KEY);
    sessionStorage.removeItem(CHOIR_AUTH_KEY);
    setIsScheduleAuthenticated(false);
    setIsAdminAuthenticated(false);
    setIsChoirAuthenticated(false);
  }, []);

  const toggleAdminMode = useCallback(() => {
    const newValue = !isAdminMode;
    localStorage.setItem(ADMIN_MODE_KEY, String(newValue));
    setIsAdminMode(newValue);
  }, [isAdminMode]);

  return {
    isScheduleAuthenticated,
    isAdminAuthenticated,
    isChoirAuthenticated,
    isAdminMode,
    loginForSchedule,
    loginForAdmin,
    loginForChoir,
    logout,
    toggleAdminMode,
  };
}
